<div class="modal-content-size">
  @if (!data) {
    <div class="header-container">
      <div class="modal-header">
        <h2 class="modal-title fkm-modal-title" id="modal-title" >
          Sammanställer aktuell leveransplan...
        </h2>
        <button type="button" class="btn-close close-x" aria-label="Close" (click)="close()">
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </div>
      <rask-busy-spinner size="5" class="spinner"></rask-busy-spinner>
    </div>
  }

  @if (data) {
    <div class="header-container">
      <div class="modal-header">
        <h2 class="modal-title fkm-modal-title" id="modal-title" >
          {{ data.mottagningsplatsNamn }} {{ month }}
        </h2>
        <button type="button" class="btn-close close-x" aria-label="Close" (click)="close()">
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </div>
      @if (data.handelssortiment.length > 0) {
        <rask-container-block>
          <rask-tabs parameterName="tab" layout="child">
            @for (h of data.handelssortiment; track h; let i = $index) {
              <rask-tab [label]="h.namn">
                <div class="row ps-3 pe-3">
                  <div class="col-6">
                    @for (l of h.leveransData; track l) {
                      <div class="data-container">
                        <div class="data-label">
                          {{l.namn}}
                        </div>
                        <div class="data-value">
                          {{l.value | number: '1.0-0'}}
                        </div>
                      </div>
                    }
                  </div>
                  <div class="col-6">
                    <rask-gauge-chart [value]="h.takt" [index]="i"></rask-gauge-chart>
                  </div>
                </div>
                <rask-takt-chart [data]="h" class="w-100"></rask-takt-chart>
              </rask-tab>
            }
          </rask-tabs>
        </rask-container-block>
      }
      @if (data.handelssortiment.length === 0) {
        <div>
          <rask-label size="3">Hittade ingen data.</rask-label>
        </div>
      }
    </div>
  }

</div>